/* ============================================================
   BB TIMER — single global countdown for the whole site.
   ONE source of truth for every giveaway timer:
     - big countdown bands (home, PDP, landing)
     - final-clock on the landing page
     - every sticky-bar mini clock
     - the landing progress meter

   Behaviour: a pure ROLLING window. The clock counts down to
   the next window boundary and, when it hits zero, immediately
   resets to a full window and keeps going — forever. Default
   window is 48 hours, so "resets every 48 hours" out of the box.
   Because it never references a fixed campaign-end date, it can
   never freeze at 00:00:00.

   CONFIG comes from window.BB_TIMER (set once in layout/theme.liquid):
     window.BB_TIMER = { anchor: "2026-07-27T00:00:00-05:00", windowHours: 48 };
   anchor      = the moment a fresh window begins (any past moment works;
                 the cycle is computed modulo the window length).
   windowHours = length of each cycle in hours (48 = reset every 2 days).

   It writes BOTH selector styles so it works on every BB section:
     data-bb-days / -hours / -mins / -secs / -stickyhours   (home + PDP)
     #days #hours #mins #secs                                (landing band)
     #fc-days #fc-hours #fc-mins #fc-secs                     (landing final clock)
     #stickyHours #stickyMins #stickySecs                    (landing sticky)
     #meterFill                                              (landing meter width)
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.BB_TIMER || {};
  var WINDOW_MS = (parseFloat(CFG.windowHours) || 48) * 3600000;

  var anchorMs = Date.parse(CFG.anchor || '');
  if (isNaN(anchorMs)) anchorMs = Date.parse('2026-07-27T00:00:00-05:00');

  function pad(n) { return String(n).padStart(2, '0'); }

  // ms left in the current rolling window (always 1..WINDOW_MS, never stuck at 0)
  function remaining(now) {
    var diff = (now - anchorMs) % WINDOW_MS;
    if (diff < 0) diff += WINDOW_MS;
    return WINDOW_MS - diff;
  }

  function setId(id, v) { var el = document.getElementById(id); if (el) el.textContent = v; }
  function setAttr(attr, v) {
    document.querySelectorAll('[data-bb-' + attr + ']').forEach(function (el) { el.textContent = v; });
  }

  function tick() {
    var r = remaining(Date.now());
    var days = Math.floor(r / 86400000);
    var hrs  = Math.floor((r / 3600000) % 24);
    var mins = Math.floor((r / 60000) % 60);
    var secs = Math.floor((r / 1000) % 60);
    var D = pad(days), H = pad(hrs), M = pad(mins), S = pad(secs), SH = pad(days * 24 + hrs);

    // home + PDP (attribute hooks)
    setAttr('days', D); setAttr('hours', H); setAttr('mins', M); setAttr('secs', S); setAttr('stickyhours', SH);

    // landing main band (id hooks)
    setId('days', D); setId('hours', H); setId('mins', M); setId('secs', S);
    // landing final clock
    setId('fc-days', D); setId('fc-hours', H); setId('fc-mins', M); setId('fc-secs', S);
    // landing sticky mini clock
    setId('stickyHours', SH); setId('stickyMins', M); setId('stickySecs', S);

    // landing progress meter: fills as the window elapses
    var fill = document.getElementById('meterFill');
    if (fill) {
      var pct = Math.min(100, Math.max(4, ((WINDOW_MS - r) / WINDOW_MS) * 100));
      fill.style.width = pct + '%';
    }
  }

  tick();
  setInterval(tick, 1000);
})();
